import { inject } from './inject';
import { NationalitySelect as BaseNationalitySelect } from './NationalitySelect';

export const NationalitySelect = inject(BaseNationalitySelect);
